import { Component, OnDestroy, Signal, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BackendConnectivityService } from './core/services/backend-connectivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements OnDestroy {
  protected readonly title = signal('ece-crm-main-frontend');
  protected readonly routeLoading = signal(false);
  protected readonly backendOffline: Signal<boolean>;

  private readonly routerSubscription: Subscription;
  private loadingTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    router: Router,
    private readonly backendConnectivity: BackendConnectivityService,
  ) {
    this.backendOffline = this.backendConnectivity.offline;
    this.routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.scheduleLoadingState();
        return;
      }
      if (event instanceof NavigationEnd) {
        sessionStorage.setItem('erp.watch.last-successful-route', event.urlAfterRedirects);
        this.clearLoadingState();
        return;
      }
      if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.clearLoadingState();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.clearLoadingState();
  }

  protected retryBackend(): void {
    this.backendConnectivity.retryNow();
  }

  private scheduleLoadingState(): void {
    if (this.loadingTimer) clearTimeout(this.loadingTimer);
    this.loadingTimer = setTimeout(() => {
      this.routeLoading.set(true);
      this.loadingTimer = null;
    }, 150);
  }

  private clearLoadingState(): void {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }
    this.routeLoading.set(false);
  }
}
